import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type QuickActionGridColumns = 2 | 3;

const columnsClass: Record<QuickActionGridColumns, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
};

export interface QuickActionGridProps {
  columns?: QuickActionGridColumns;
  className?: string;
  children: ReactNode;
}

export function QuickActionGrid({
  columns = 3,
  className,
  children,
}: QuickActionGridProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-4",
        columnsClass[columns],
        className,
      )}
    >
      {children}
    </div>
  );
}
